// #144: Kettenglieder tragen selbst keine ETO-ID — die ID gehört bei ETO zum ganzen Szenario.
// Angezeigt wird sie abgeleitet als „DTP_2 · 3/10" (Kette · Position/Gliederzahl). Bewusst nur
// Anzeige: eine gespeicherte Glied-ID bräche den Neuimport-Abgleich (Entscheidung 06.10.).
export function sourceLabel(
  sourceRef: string | null,
  chains: { source_ref: string | null; step: number; total: number }[],
): string | null {
  if (sourceRef) return sourceRef;
  const parts = chains
    .filter((c) => c.source_ref)
    .map((c) => `${c.source_ref} · ${c.step}/${c.total}`);
  return parts.length > 0 ? parts.join(', ') : null;
}

/**
 * #144: Kurzform für die schmale Baumzeile (380-px-Spalte): bei mehreren Ketten nur die erste
 * plus „ +N"; der volle Text (`sourceLabel`) gehört in ein `title`-Attribut.
 */
export function sourceLabelShort(
  sourceRef: string | null,
  chains: { source_ref: string | null; step: number; total: number }[],
): { short: string; full: string } | null {
  const full = sourceLabel(sourceRef, chains);
  if (full === null) return null;
  if (sourceRef) return { short: sourceRef, full };
  const withRef = chains.filter((c) => c.source_ref);
  const first = withRef[0];
  if (!first) return null;
  const rest = withRef.length - 1;
  return {
    short: `${first.source_ref} · ${first.step}/${first.total}${rest > 0 ? ` +${rest}` : ''}`,
    full,
  };
}

/** Suchbegriffe für matchesQuery: eigene Quell-ID + alle Ketten-IDs (die Suche gilt auch bei
 *  ausgeschaltetem show_source_ref). */
export function sourceSearchTerms(
  sourceRef: string | null,
  chains: { source_ref: string | null }[],
): (string | null)[] {
  return [sourceRef, ...chains.map((c) => c.source_ref)];
}
